import { render, staticRenderFns } from "./aboutQyjg.vue?vue&type=template&id=93fa8ea4&scoped=true&"
import script from "./aboutQyjg.vue?vue&type=script&lang=js&"
export * from "./aboutQyjg.vue?vue&type=script&lang=js&"
import style0 from "./aboutQyjg.vue?vue&type=style&index=0&id=93fa8ea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fa8ea4",
  null
  
)

export default component.exports